// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608211834/js/" + chunkId + "." + {"44":"0c780d18","225":"c13145fd","481":"2eb4448f","486":"a0f31635","770":"1f5c9520"}[chunkId] + ".0.2727147583571745.chunk.js";
};